import React from "react";
import UpdateIcon from "@mui/icons-material/Update";
import { Fab } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoadingScreen } from "../../store/slices/loading";

const Refresher = ({setNeedRefreshData} ) => {
  const dispatch = useDispatch();
  const handleClick = ()=>{
    dispatch(showLoadingScreen());
    setNeedRefreshData();
  }
  return (
    <Fab
      size="large"
      color="primary"
      aria-label="add"
      sx={{ position: "fixed", bottom: "20px", right: "20px" }}
      onClick={handleClick}
    >
      <UpdateIcon />
    </Fab>
  );
};
export default Refresher;
